import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const selectClass = 'w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700';

export const MomentSearch = ({ filters, setFilters, people, origins, active, onClear }) => {
  const [text, setText] = useState(filters.q);

  useEffect(() => {
    const t = setTimeout(() => {
      setFilters((f) => (f.q === text ? f : { ...f, q: text }));
    }, 300);
    return () => clearTimeout(t);
  }, [text, setFilters]);

  const set = (key) => (e) => setFilters((f) => ({ ...f, [key]: e.target.value }));

  const clear = () => {
    setText('');
    onClear();
  };

  return (
    <div className="mb-6 space-y-3">
      <div className="relative">
        <SafeIcon icon={FiIcons.FiSearch} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          type="search"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Search titles and notes"
          className="w-full rounded-2xl border border-slate-200 bg-white py-3 pl-11 pr-4 text-[15px] font-medium text-slate-900 placeholder:text-slate-400 focus:border-slate-400 focus:outline-none"
        />
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        <select aria-label="Person" value={filters.contactId} onChange={set('contactId')} className={selectClass}>
          <option value="">Anyone</option>
          {people.map((p) => <option key={p.id} value={p.id}>{p.full_name || 'Contact'}{p.company ? ` · ${p.company}` : ''}</option>)}
        </select>
        <select aria-label="Origin" value={filters.originId} onChange={set('originId')} className={selectClass}>
          <option value="">Any origin</option>
          {origins.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
        <select aria-label="Sort" value={filters.sort} onChange={set('sort')} className={selectClass}>
          <option value="newest">Newest first</option>
          <option value="oldest">Oldest first</option>
          <option value="updated">Recently updated</option>
        </select>
        <label className="text-xs font-semibold text-slate-500">
          From
          <input type="date" value={filters.from} max={filters.to || undefined} onChange={set('from')} className={`${selectClass} mt-1`} />
        </label>
        <label className="text-xs font-semibold text-slate-500">
          To
          <input type="date" value={filters.to} min={filters.from || undefined} onChange={set('to')} className={`${selectClass} mt-1`} />
        </label>
        {active && (
          <button type="button" onClick={clear} className="self-end rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-50">
            Clear filters
          </button>
        )}
      </div>
    </div>
  );
};